<template>
  <main>
    <div class="page-area">
      <div class="breadcumb-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="breadcrumb text-center">
              <div class="section-headline white-headline">
                <h3>海星云客户端下载</h3>
              </div>
              <ul class="breadcrumb-bg">
                <li>海星云客户端下载</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-area bg-color-1 area-padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="section-headline white-headline text-center">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="product-content text-center">
                  <div class="layer-1-3">
                    <a
                      href="https://www.speedtest.net/zh-Hans"
                      target="blank"
                      class="ready-btn"
                      >测速</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <p>海星云游戏平台支持从720P到4K画质的流畅游戏体验。您需要至少10Mbps的网速来支持高清的画质，25Mbps以上的建议网速来体验4K，60FPS的效果。</p> -->
        <div class="row">
          <div class="best-product">
            <!-- Start single product -->
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/new/img/product/p4.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- End single product -->
          </div>
        </div>
      </div>
    </div>
    <!-- End breadcumb Area -->
    <!-- Start Product Area -->
    <div class="product-area bg-color-1 area-padding">
      <div class="container">
        <div class="row"></div>
        <div class="row">
          <div class="best-product">
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">Windows</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/win.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <!-- 这里是判断电脑是32 还是 64 部分 -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于WINDOWS XP及以上</span>
                    </div>
                    <div class="text-center" style="display: flex; justify-content: center; margin-top: 10px">
                      <div style="">
                        <div class="layer-1-3">
                          <a
                            href='https://download.haixingcloud.com/static/download/haixingcloud-setup.exe'
                            class="ready-btn"
                          >Win 64位下载</a
                          >
                        </div>
                        <div class="version-update">
                          <div>版本&nbsp;{{ pcNewVer.version_number || "" }}</div>
                          <div>
                            更新日期&nbsp;:&nbsp;&nbsp;{{
                              pcNewVer.createdat | fmtDate
                            }}
                          </div>
                        </div>
                      </div>
                      <div style="margin-left: 20px">
                        <div class="layer-1-3">
                          <a
                            href='https://download.haixingcloud.com/static/download/haixingcloud-setup-x86.exe'
                            class="ready-btn"
                          >Win 32位下载</a
                          >
                        </div>
                        <div class="version-update">
                          <div>版本&nbsp;{{ pc32NewVer.version_number || "" }}</div>
                          <div>
                            更新日期&nbsp;:&nbsp;&nbsp;{{
                              pc32NewVer.createdat | fmtDate
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="version-box"></div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">Mac</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/new/img/product/p2.jpg"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于MacOS 10.15及以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/StarVictory.dmg"
                        class="ready-btn"
                        >MAC下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>版本&nbsp;{{ macNewVer.version_number || "" }}</div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          macNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">安卓</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/azsj.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于Android 8.0以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/haixingcloud-android-latest.apk"
                        class="ready-btn"
                        >安卓下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>
                        版本&nbsp;{{ androidNewVer.version_number || "" }}
                      </div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          androidNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">IOS</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/ios.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span style="color: #12102f">适用于IOS 9.0及以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a class="ready-btn">敬请期待</a>
                    </div>
                    <div class="version-update" style="color: #12102f">
                      <div>版本&nbsp;{{ IOSNewVer.version_number || "" }}</div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          IOSNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- Start single product -->
            <div class="col-md-6 col-sm-12 col-xs-12">
              <div class="single-product">
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product">
                    <div class="product-img">
                      <span class="category">安卓TV</span>
                      <img
                        draggable="false"
                        class="first-img"
                        src="../assets/images/xz/anzds.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <!-- Start product content -->
                <div class="col-md-12 col-sm-6 col-xs-12">
                  <div class="product-content text-center">
                    <div class="launch-date">
                      <span>适用于Android 8.0以上</span>
                    </div>
                    <div class="version-box"></div>
                    <div class="layer-1-3">
                      <a
                        href="https://download.haixingcloud.com/static/download/haixingcloud-android-tv-latest.apk"
                        class="ready-btn"
                        >安卓TV下载</a
                      >
                    </div>
                    <div class="version-update">
                      <div>
                        版本&nbsp;{{ androidTVNewVer.version_number || "" }}
                      </div>
                      <div>
                        更新日期&nbsp;:&nbsp;&nbsp;{{
                          androidTVNewVer.createdat | fmtDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End product content -->
              </div>
            </div>
            <!-- End single product -->
          </div>
        </div>
      </div>
    </div>
    <!-- 全局qq和微信联系方式 index中有全局 -->
    <div class="hotline">
      <i class="fa fa-qq link"></i>
      <div class="qrcode-div">
        <img
          draggable="false"
          style="width: 100%; height: 100%"
          class="image"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
        />
      </div>
    </div>
    <div class="hotline2">
      <i class="fa fa-wechat link-wechat"></i>
      <div class="qrcode-div2">
        <img
          class="image"
          draggable="false"
          :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/Wechat2.jpg`"
        />
      </div>
    </div>
    <a class="phone_download" v-show="this.phone_download" :href="this.FG_link">
      <!-- <div class="pd_div"></div> -->
      <div class="pd_img">
        <img :src="this.FG_img" class="pd_img" />
      </div>
    </a>
  </main>
</template>
<script>
import { formatDate } from '@/common/utils.js'
export default {
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享3070, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      xiazai: [
        {
          url: '../../static/images/download/pc',
          name: 'Windows（X64）',
          logo:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/download/pc64.png',
          link:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/download/haixingcloud-setup.exe',
          alt: '海星云PC客户端'
        },
        {
          url: '../../static/images/download/Android',
          name: 'Android',
          logo:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/download/Android.png',
          link:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/download/haixingcloud-android-latest.apk',
          alt: '海星云Android客户端'
        },
        {
          url: '../../static/images/download/IOS',
          name: 'MAC',
          logo:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/download/iOS.png',
          link: 'javascript:void(0)',
          alt: '海星云MAC客户端',
          shouce: ''
        },
        {
          url: '../../static/images/download/pc',
          name: 'Windows网吧版（X64）',
          logo:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/download/pc64.png',
          link:
            'https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/download/%E6%B5%B7%E6%98%9F%E4%BA%91%E7%BB%BF%E8%89%B2%E7%89%88-v2.1.11.zip',
          alt: '海星云PC客户端(网吧版)',
          style: 'border-right:none;',
          shouce: ''
        }
      ],

      pcVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      pc32Ver: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      macVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      androidVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      IOSVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },
      androidTVVer: {
        new_version: {},
        min_version: {},
        newest_version: {}
      },

      // 判断设备图
      FG_img: require('../assets/images/apple.png'),
      FG_link: '',
      win64or32: 64
    }
  },
  computed: {
    pcNewVer () {
      // return this.pcVer.new_version
      if (this.pcVer.newest_version !== undefined) {
        return (new Date(this.pcVer.new_version.createdat_str) > new Date(this.pcVer.newest_version.createdat_str)) ? this.pcVer.new_version : this.pcVer.newest_version
      }
      return this.pcVer.new_version
    },
    pc32NewVer () {
      // return this.pcVer.new_version
      if (this.pc32Ver.newest_version !== undefined) {
        return (new Date(this.pc32Ver.new_version.createdat_str) > new Date(this.pc32Ver.newest_version.createdat_str)) ? this.pc32Ver.new_version : this.pc32Ver.newest_version
      }
      return this.pc32Ver.new_version
    },
    macNewVer () {
      if (this.macVer.newest_version !== undefined) {
        return (new Date(this.macVer.new_version.createdat_str) > new Date(this.macVer.newest_version.createdat_str)) ? this.macVer.new_version : this.macVer.newest_version
      }
      return this.macVer.new_version
    },
    androidNewVer () {
      if (this.androidVer.newest_version !== undefined) {
        return (new Date(this.androidVer.new_version.createdat_str) > new Date(this.androidVer.newest_version.createdat_str)) ? this.androidVer.new_version : this.androidVer.newest_version
      }
      return this.androidVer.new_version
    },
    IOSNewVer () {
      if (this.IOSVer.newest_version !== undefined) {
        return (new Date(this.IOSVer.new_version.createdat_str) > new Date(this.IOSVer.newest_version.createdat_str)) ? this.IOSVer.new_version : this.IOSVer.newest_version
      }
      return this.IOSVer.new_version
    },
    androidTVNewVer () {
      if (this.androidTVVer.newest_version !== undefined) {
        return (new Date(this.androidTVVer.new_version.createdat_str) > new Date(this.androidTVVer.newest_version.createdat_str)) ? this.androidTVVer.new_version : this.androidTVVer.newest_version
      }
      return this.androidTVVer.new_version
    }
  },
  filters: {
    fmtDate: function (value) {
      if (!value) return
      return formatDate(new Date(value), 'yyyy年MM月dd日')
    }
  },
  mounted () {
    this.getPcVer()
    this.get32PcVer()
    this.getMacVer()
    this.getAndroidVer()
    this.getAndroidTVVer()
    this.getIOSVer()
    this._isMobile()
    /*
    //接口获取下载链接
    axios.all([this.http.getLink(1),this.http.getLink(2),this.http.getLink(3),this.http.getLink(4)])
    .then(axios.spread((res1, res2,res3,res4)=>{
        if(res1.status === 200 && res1.data.code === 200){
          // this.xiazai[0].
        }
        if(res2.status === 200 && res2.data.code === 200){
        }
        if(res3.status === 200 && res3.data.code === 200){
        }
        if(res4.status === 200 && res4.data.code === 200){
        }
    }))
    */
    var agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
      this.win64or32 = 64
    } else {
      this.win64or32 = 32
    }
  },
  methods: {
    open () {
      this.$alert('<strong>打开App Store搜索"海星云"，下载海星云APP</strong>', '海星云提示您', {
        dangerouslyUseHTMLString: true
      })
    },
    _isMobile () {
      // const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (navigator.userAgent.match(/(pad|pod|iPhone|iPod|ios|iPad)/i)) {
        this.FG_img = require('../assets/images/apple.png')
        this.phone_download = true
        this.FG_link = 'https://testflight.apple.com/join/XnoiWO1x'
      } else if (navigator.userAgent.match(/(Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.FG_img = require('../assets/images/Android.png')
        this.phone_download = true
        this.FG_link = 'https://download.haixingcloud.com/static/download/haixingcloud-android-latest.apk'
      } else {
        this.phone_download = false
      }
      // return flag
    },
    getPcVer () {
      this.http.getLink(3).then(r => {
        this.pcVer = r.data.data
      })
    },
    get32PcVer () {
      this.http.getLink(5).then(r => {
        this.pc32Ver = r.data.data
      })
    },
    getMacVer () {
      this.http.getLink(2).then(r => {
        this.macVer = r.data.data
      })
    },
    getAndroidVer () {
      this.http.getLink(1).then(r => {
        this.androidVer = r.data.data
      })
    },
    getIOSVer () {
      this.http.getLink(6).then(r => {
        this.IOSVer = r.data.data
      })
    },
    getAndroidTVVer () {
      this.http.getLink(4).then(r => {
        this.androidTVVer = r.data.data
      })
    }
  }
}
</script>
<style scoped>
.best-product {
  padding-top: 0px;
}
.version-update {
  margin-top: 10px;
  font-size: 12px;
  color: #e3e3e8;
  opacity: 0.8;
}
.phone_download {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 56px;
  width: 100%;
  z-index: 100;

  background-color: rgba(0, 0, 0, 0.31);
  border-radius: 5px;
  font-family: sans-serif;
  text-align: center;
  line-height: 1;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  // max-width: 50%;
  // max-height: 50%;
  padding: 20px 40px;
}
.pd_img {
  width: 100px;
  height: 27.2px;
  margin: -8px auto 0;
  position: relative;
  display: block;
}
.pd_img img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/DownLoad.vue